module.exports = "<app-modal\n  title=\"New Section\"\n  [close]=\"close\"\n  [submit]=\"submit.bind(this)\"\n>\n  <div *ngIf=\"!isLoading\" class=\"field\">\n    <span class=\"caption\">Title</span>\n\n    <input\n      name=\"title\"\n      type=\"text\"\n      [(ngModel)]=\"section.title\"\n      [formControl]=\"titleCtrl\"\n    />\n  </div>\n\n  <app-loading *ngIf=\"isLoading\"></app-loading>\n</app-modal>\n"


//////////////////
// WEBPACK FOOTER
// /Users/nide/Code/3dissue/3d-issue-hubs-ui/src/app/edit/sections-panel/edit-section-modal/edit-section-modal.component.html
// module id = ../../../../../src/app/edit/sections-panel/edit-section-modal/edit-section-modal.component.html
// module chunks = main